module.exports = __webpack_public_path__ + "49ae02f8aab9062cba2247f1e71c7283.pdf";